
import { useNavigate, useParams } from 'react-router-dom';
import React, { useEffect, useRef, useState } from "react";

import {
  AppLayout,
  Box,
  BreadcrumbGroup,
  Button,
  Checkbox,
  ColumnLayout,
  Container,
  ContentLayout,
  Flashbar,
  FormField,
  Header,
  HelpPanel,
  Input,
  Link,
  Modal,
  SideNavigation,
  SpaceBetween,
  Spinner,
  SplitPanel,
  StatusIndicator,
} from "@cloudscape-design/components";
// import { Navigation } from "../../../components/app/Navigation";
import Icon from "@cloudscape-design/components/icon";
// import { Grid,  } from '@cloudscape-design/components';
import DetailDashboard from './components/DetailDashboard';
import { Navigation } from '../../../components/app/Navigation';
import { generateClient } from 'aws-amplify/api';
import { deleteTenant, updateTenant } from '../../../graphql/mutations';
import { listTenants } from '../../../graphql/queries';
import { ListTenantsQueryVariables } from '../../../API';
import { ListTenant } from '../tenant/data/data';
import DetailOverview from './components/DetailOverview';
import { fetchAuthSession } from "aws-amplify/auth";

// get user belong to what group and make it into string
async function checkUserGroup() {
  try {
    const { tokens } = await fetchAuthSession();
    // Normalize user groups to be an array of strings
    const groups = tokens?.accessToken.payload["cognito:groups"];
    if (Array.isArray(groups)) {
      return groups as string[]; // Safe to cast as string[]
    } else if (typeof groups === "string") {
      return [groups]; // Convert a single string to an array
    } else {
      return []; // Default to an empty array if not an array or string
    }
  } catch (error) {
    console.error("Error fetching user groups:", error);
    return []; // Default to an empty array in case of an error
  }
}

async function checkCurrentUser(): Promise<{
  username: string;
  email: string | null;
}> {
  try {
    const { tokens } = await fetchAuthSession();
    // extract the user's information from the accessToken or idTOken
    const currentUser = tokens?.idToken?.payload || tokens?.accessToken.payload;

    if (currentUser) {
      const username =
        typeof currentUser["cognito:username"] === "string"
          ? currentUser["cognito:username"]
          : ""; //fallback if username is empty

      const email =
        typeof currentUser.email === "string" ? currentUser.email : null;
      return { username, email };
    } else {
      console.error("No User Infromation found.");
      return { username: "", email: null };
    }
  } catch (error) {
    console.error("Error fetching current user information:", error);
    return { username: "", email: null };
  }
}


interface FlashbarItem {
  type: "info" | "warning" | "error" | "success"; // Adjust according to your requirements
  dismissible: boolean;
  dismissLabel: string;
  onDismiss: () => void;
  content: React.ReactNode;
  id: string;
}

async function deleteTenantApi(id: string) {
  try {
    const client = generateClient();
    await client.graphql({
      query: deleteTenant,
      authMode: 'userPool',
      variables: {
        input: {
          id,
        },
      },
    });
  } catch (err) {
    console.log("Error deleting vehicle: ", err);
  }
}

async function updateTenantApi(id: string, tenantname: string, subtenant:string, address: string, contact: string, phone: string, statusenable:string, servicepackage: string, status: boolean) {
  try {
    const client = generateClient();
    await client.graphql({
      query: updateTenant,
      authMode: 'userPool',
      variables: {
        input: {
          id: id,
          tenantname: tenantname,
          subtenant : subtenant,
          address: address,
          contact: contact,
          phone: phone,
          status: statusenable,
          servicepackage: servicepackage,
          statuspayment: status
        }
      }
    });
  } catch (err) {
    console.log("Error updating tenant: ", err);
  }
}





const TenantDetail: React.FC = () => {

  const [activeHref, setActiveHref] = React.useState("/system/tenants");
  const [helpPanelOpen, setHelpPanelOpen] = useState(false); // State untuk mengontrol panel bantuan
  const { name } = useParams<{ name: string }>();
  const [isModalDeleteVisible, setModalDeleteVisible] = useState(false);
  const [isModalUpdateVisible, setModalUpdateVisible] = useState(false);
  const [itemsFlashbar, setItemsFlashbar] = useState<FlashbarItem[]>([]);
  const [itemsFlashbar2, setItemsFlashbar2] = useState<FlashbarItem[]>([]);
  const navigate = useNavigate();
  let { TenantName } = useParams();

  const [tenantList, setTenantList] = useState<ListTenant[]>([]);


  const [tenantName, settenantName] = useState("");
  const [subtenantName, setsubtenantName] = useState("");
  const [tenantAddress, settenantAddress] = useState("");
  const [tenantContact, settenantContact] = useState("");
  const [tenantPhone, settenantPhone] = useState("");
  const [tenantStatusenable, settenantStatusenable] = useState("");
  const [tenantServicePackage, settenantServicePackage] = useState("");
  const [tenantStatusPayment, settenantStatusPayment] = useState(false);
  const [isLoading, setIsLoading] = React.useState(true);
  const [checked, setChecked] = useState(false);
  const [userGroups, setUserGroups] = useState<string[]>([])

  const [currentUser, setCurrentUser] = useState<string>("");
  const [currentUserEmail, setCurrentUserEmail] = useState<string>("");

  // TimeStamp for log Format
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth() + 1;
  const day = now.getDate();
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const seconds = String(now.getSeconds()).padStart(2, "0");
  const timestamp = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;


  useEffect(() => {
    async function initialize() {
      const groups = await checkUserGroup();
      const user = await checkCurrentUser();
      setCurrentUser(user.username);
      setCurrentUserEmail(user.email ?? "");
      setUserGroups(groups);
      fetchTenant();
    } initialize();
  }, []);

  const fetchTenant = async (limit = 100) => {
    try {
      const client = generateClient();
      let nextToken: string | null = null;
      let allTenants: ListTenant[] = [];

      do {
        const variables: ListTenantsQueryVariables = { limit, nextToken };
        let response = await client.graphql({
          query: listTenants,
          authMode: 'userPool',
          variables,
        });

        const tenants = response.data.listTenants.items;
        nextToken = response.data.listTenants.nextToken ?? null;
        //alert(tenants);
        //alert("test")
        const newTenants: ListTenant[] = tenants.map((tenant: any) => ({
          id: tenant.id,
          TenantName: tenant.tenantname ?? "",
          Subtenant: tenant.subtenant ?? "",
          Address: tenant.address ?? "",
          Contact: tenant.contact ?? "",
          Phone: tenant.phone ?? "",
          Status: tenant.status ?? "",
          ServicePacakge: tenant.servicepackage ?? "",
          StatusPayment: Boolean(tenant.statuspayment),

        }));

        allTenants = [...allTenants, ...newTenants];

      } while (nextToken);

      const filteredTenants = allTenants.filter(tenant => tenant.TenantName === TenantName);
      // alert("ini log");
      setTenantList(filteredTenants);
      setIsLoading(false);

    } catch (err) {
      console.log("error fetching tenants: ", err);
      setItemsFlashbar([
        {
          type: "error",
          dismissible: true,
          dismissLabel: "Dismiss message",
          onDismiss: () => setItemsFlashbar([]),
          content: "Error fetching Tenant data.",
          id: "message_3",
        },
      ]);
    }
  };

  const handleDelete = async () => {
    if (tenantList.length > 0) {
      // Extract the ID of the first vehicle in the list (you can customize this logic)
      const tenantIdToDelete = tenantList[0].id;
      await deleteTenantApi(tenantIdToDelete);

      // Log Transaction of delete tenant
      console.log(
        `Tenant Transaction Log (Delete Item):
        Tenant ID : ${tenantList[0].id}
        Tenant Name : ${tenantList[0].TenantName}
        Tenant Subtenant :  ${tenantList[0].Subtenant}
        Tenant Address : ${tenantList[0].Address}
        Tenant Contact : ${tenantList[0].Contact}
        Tenant Phone : ${tenantList[0].Phone}
        Tenant Status : ${tenantList[0].Status}
        Tenant Service Package : ${tenantList[0].ServicePacakge}
        Tenant Status Payment : ${tenantList[0].StatusPayment}
        User Group: ${userGroups}
        User : ${currentUser}
        User Email : ${currentUserEmail}
        Timestamp : ${timestamp}`
      );

      setItemsFlashbar2([
        {
          type: "success",
          dismissible: true,
          dismissLabel: "Dismiss message",
          onDismiss: () => setItemsFlashbar2([]),
          content: "Tenant successfully deleted.",
          id: "message_4",
        },
      ]);
      navigate('/system/tenants');
    }
  };

  const handleUpdate = async () => {
    setModalUpdateVisible(false);
    if (tenantList.length > 0) {
      const tenantIdToUpdate = tenantList[0].id;
      await updateTenantApi(tenantIdToUpdate, tenantName, subtenantName, tenantAddress, tenantContact, tenantPhone, tenantStatusenable, tenantServicePackage, tenantStatusPayment);
      // Log Transaction of update tenant
      console.log(
        `Tenant Transaction Log (Update Item):
        Tenant ID : ${tenantList[0].id}
        Tenant Name : ${tenantName}
        Tenant Subtenant : ${subtenantName}
        Tenant Address : ${tenantAddress}
        Tenant Contact : ${tenantContact}
        Tenant Phone : ${tenantPhone}
        Tenant Status : ${tenantStatusenable}
        Tenant Service Package : ${tenantServicePackage}
        Tenant Status Payment: ${tenantStatusPayment}
        User Group: ${userGroups}
        User : ${currentUser}
        User Email : ${currentUserEmail}
        Timestamp : ${timestamp}`
      );
      
      setItemsFlashbar2([
        {
          type: "success",
          dismissible: true,
          dismissLabel: "Dismiss message",
          onDismiss: () => setItemsFlashbar2([]),
          content: "Tenant successfully updated.",
          id: "message_5",
        },
      ]);
      fetchTenant(); // Refresh the vehicle list after update
    }
  };

  const handleEditButtonClick = () => {
    setModalUpdateVisible(true);
    if (tenantList.length > 0) {
      const tenatss = tenantList[0];
      settenantName(tenatss.TenantName);
      setsubtenantName(tenatss.Subtenant)
      settenantAddress(tenatss.Address);
      settenantContact(tenatss.Contact);
      settenantPhone(tenatss.Phone);
      settenantStatusenable(tenatss.Status);
      settenantServicePackage(tenatss.ServicePacakge);
      settenantStatusPayment(tenatss.StatusPayment);
      setModalUpdateVisible(true);
    }
  };

  const handleDeleteConfirmation = () => {
    setModalDeleteVisible(true);
  };


  return (
    <>
      <AppLayout
        breadcrumbs={
          <BreadcrumbGroup
            items={[
              {
                text: "System",
                href: "/system",
              },
              {
                text: "Tenants",
                href: "/system/tenants",
              },
              {
                text: `Detail Tenant : ${TenantName}`,
                href: `/system/tenants/ ${TenantName}`,
              },
            ]}
          />
        }
        navigation={
          <Navigation
            activeHref={activeHref}
            setActiveHref={setActiveHref} adminSubMenuOpen={false} setAdminSubMenuOpen={function (href: boolean): void {
              throw new Error('Function not implemented.');
            }}              // adminSubMenuOpen={adminSubMenuOpen} // Mengirim state submenu Admin ke komponen Navigation
          // setAdminSubMenuOpen={setAdminSubMenuOpen} // Mengirim fungsi untuk mengubah state submenu Admin ke komponen Navigation
          />
        }
        //navigationOpen={true}
        //   navigation={
        //     <Navigation activeHref={activeHref} setActiveHref={setActiveHref} />
        //   }
        //notifications={
        //  <Flashbar
        //    items={[
        //      {
        //        type: "info",
        //        dismissible: true,
        //        content: "This is an info flash message.",
        //        id: "message_1",
        //      },
        //    ]}
        //  />
        //}
        toolsOpen={helpPanelOpen} // Menggunakan state untuk menentukan apakah panel bantuan terbuka atau tidak
        onToolsChange={() => setHelpPanelOpen(!helpPanelOpen)}
        tools={
          <HelpPanel
            footer={
              <div>
                <h3>
                  Learn more <Icon name="external" />
                </h3>
                <ul>
                  <li>
                    <a href="">Link to documentation</a>
                  </li>
                  <li>
                    <a href="">Link to documentation</a>
                  </li>
                </ul>
              </div>
            }
            header={<h2>Help panel title (h2)</h2>}
          >
            <div>
              <p>
                This is a paragraph with some <b>bold text</b> and also some{" "}
                <i>italic text</i>.
              </p>

              <h3>h3 section header</h3>
              <ul>
                <li>Unordered list item.</li>
                <li>Unordered list item.</li>
              </ul>

              <h4>h4 section header</h4>
              <p>
                Code can be formatted as lines of code or blocks of code. Add
                inline code <code>like this</code> using a{" "}
                <code>{"<code>"}</code> tag.
                <pre>
                  Or format blocks of code (like this) using a{" "}
                  <code>{"<pre>"}</code> tag.
                </pre>
              </p>

              <h5>h5 section header</h5>
              <dl>
                <dt>This is a term</dt>
                <dd>This is its description.</dd>
                <dt>This is a term</dt>
                <dd>This is its description</dd>
              </dl>
            </div>
          </HelpPanel>
        }
        content={
          <ContentLayout
            header={
              <Header
                variant="h1"
                actions={
                  <SpaceBetween size="s" direction="horizontal">

                    <Button onClick={handleEditButtonClick}>Edit</Button>
                    <Button onClick={handleDeleteConfirmation}>Delete</Button>
                  </SpaceBetween>
                }
                info={
                  <Link
                    variant="info"
                    onFollow={() => setHelpPanelOpen(!helpPanelOpen)}
                  >
                    Info
                  </Link>
                }

              >
                {activeHref === "/system/tenants"
                  ? `Tenant : ${TenantName}`
                  : ""}
              </Header>
            }
          >

            <div className="contentPlaceholder" style={{ marginTop: isLoading ? '160px' : '0px' }}>
              {/*<DetailDashboard />*/}
              {isLoading ? (
                <Box textAlign='center'>
                  <Spinner size='large' />
                  <Box variant='p'>Loading Tenant data...</Box>
                </Box>
              ) : (
                <Container>
                  <Flashbar items={itemsFlashbar2} />
                  <ColumnLayout columns={2} minColumnWidth={500}>
                    <div>
                      <div>
                        <h1>Tenant Profile </h1>
                        <h3>Name : {TenantName}</h3>
                      </div>
                      <div style={{ marginBottom: 20 }}>
                        <Flashbar items={itemsFlashbar} />
                      </div>

                      {tenantList.length > 0 ? (
                        tenantList.map(tenant => (
                          <ColumnLayout key={tenant.TenantName} borders='horizontal' columns={2}>
                            <div>Subtenant</div>
                            <div style={{ fontWeight: 'bold' }}>{tenant.Subtenant}</div>
                            <div>Address</div>
                            <div style={{ fontWeight: 'bold' }}>{tenant.Address}</div>
                            <div>Contact Person</div>
                            <div style={{ fontWeight: 'bold' }}>{tenant.Contact}</div>                            
                            <div>Phone</div>
                            <div style={{ fontWeight: 'bold' }}>{tenant.Phone}</div>
                            <div>Status</div>
                            <div style={{ fontWeight: 'bold' }}>{tenant.Status}</div>
                            <div>Service Package</div>
                            <div>{tenant.ServicePacakge}</div>
                            <div>Status Payment</div>
                            <div><StatusIndicator type={tenant.StatusPayment ? "success" : "error"}>
                              {tenant.StatusPayment ? "Paid" : "Not Paid"}</StatusIndicator></div>
                          </ColumnLayout>
                        ))
                      ) : (
                        <div>No tenant data found.</div>
                      )}

                    </div>

                    <DetailOverview />
                  </ColumnLayout>
                </Container>
              )}


            </div>

          </ContentLayout>
        }
        splitPanel={
          <SplitPanel header="Split panel header">
            Split panel content
          </SplitPanel>
        }
      />
      <Modal
        onDismiss={() => setModalDeleteVisible(false)}
        visible={isModalDeleteVisible}
        closeAriaLabel="Close modal"
        header="Confirm Delete"
        footer={
          <SpaceBetween direction="horizontal" size="s">
            <Button variant="link" onClick={() => setModalDeleteVisible(false)}>Cancel</Button>
            <Button variant="primary" onClick={handleDelete}>Confirm</Button>
          </SpaceBetween>
        }
      >
        <p>Are you sure you want to delete this Tenant?</p>
      </Modal>
      <Modal
        onDismiss={() => setModalUpdateVisible(false)}
        visible={isModalUpdateVisible}
        footer={
          <Box float="right">
            <SpaceBetween direction="horizontal" size="xs">
              <Button variant="link" onClick={() => setModalUpdateVisible(false)}>Cancel</Button>
              <Button variant="primary" onClick={handleUpdate}>Submit</Button>
            </SpaceBetween>
          </Box>
        }
        header="Edit Tenant"
      >
        <Container>
        <SpaceBetween direction='vertical' size='l'>
            <FormField label="Tenant Name">
              <Input value={tenantName} onChange={({ detail }) => settenantName(detail.value)} />
            </FormField>
            <FormField label="Subtenant">
              <Input value={subtenantName} onChange={({ detail }) => setsubtenantName(detail.value)} />
            </FormField>
            <FormField label="Address">
              <Input value={tenantAddress} onChange={({ detail }) => settenantAddress(detail.value)} />
            </FormField>
            <FormField label="Contact">
              <Input value={tenantContact} onChange={({ detail }) => settenantContact(detail.value)} />
            </FormField>
            <FormField label="Phone">
              <Input value={tenantPhone} onChange={({ detail }) => settenantPhone(detail.value)} />
            </FormField>
            <FormField label="Status">
              <Input value={tenantStatusenable} onChange={({ detail }) => settenantStatusenable(detail.value)} />
            </FormField>
            {/*<FormField label="Service Package">
              <Select
                options={[
                  { label: "Gold", value: "1" },
                  { label: "Silver", value: "2" },
                  { label: "Basic", value: "3" },
                ]}
                selectedOption={null}
              />
            </FormField>*/}
            <FormField label="Service Package">
              <Input value={tenantServicePackage} onChange={({ detail }) => settenantServicePackage(detail.value)} />

            </FormField>
            <FormField label="Status Payment">
              <Checkbox
                checked={tenantStatusPayment}
                onChange={({ detail }) => {

                  settenantStatusPayment(detail.checked);
                }}
              >
                Paid
              </Checkbox>
            </FormField>
           </SpaceBetween>
        </Container>




      </Modal>




    </>
  );
}

export default TenantDetail;
